<template>
<div class="main-wrapper">
  <div class="title">
      <!--<p>SRCC检测任务单详情</p>-->
      </div>
  <div class="normal-text right-align">
        <p>任务单号：{{contract_data.project_display_no}}</p>
      </div>
      <div class="company normal-text">
      <div class="customer-info">
        <p><span class="bold-text1">委托方(甲方)：</span><span class="com-name">{{contract_data.customer.customerCompany.name}}</span></p>
        <p>地址/邮编：{{contract_data.customer.customerCompany.address}}</p>
        <p>电话/传真：{{contract_data.customer.customerCompany.telephone}}{{contract_data.customer.customerCompany.fax?('/'+contract_data.customer.customerCompany.fax):''}}</p>
      </div>
      <div class="two-date right-align">
          <p>委托送检日期：{{contract_data.apply_date}}</p>
          <p>约定完成日期：{{contract_data.reportInfo.completeDate}}</p>
        </div>
    </div>
    <div class="ins-content">
      <div class="normal-text">
        <p>
          <span class="bold-text1">样品及检测信息：</span>
        </p>
      </div>
      <div class="loop-sample-wrapper">
        <div v-for="(sa,index) in contract_data.sample"
                :key="sa.name+index"
                class="sample-info-item-wrapper">
                <p>{{sa.name}}{{sa.model?'||'+sa.model:''}}{{sa.property?'||'+sa.property:''}}</p>
                <div class="ins-wrapper">
                  <div
                    v-for="(one,subindex) in sa.testItems"
                    :key="subindex"
                    class="sub_iis_wrapper"
                  >
                    <div  class="sample-info-item sub-siis">{{one.name.product_name}}-{{one.choice.text}}
                      <span v-for="i in one.single_choice.filter(val=>val!==undefined&&val!==null&&Object.keys(val).length!==0)" :key="i.text">{{'('+i.text+')'}}</span>
                      <span v-for="j in one.multi_choice" :key="j.text">{{'、'+j.text}}</span></div>
                    <p  class="extra-ins sub-siis">{{(one.amount>1)?('检测次数:'+one.amount):''}}</p>
                    <p  class="extra-ins sub-siis">{{one.remark?'备注：'+one.remark:''}}</p>
                  </div>
                </div>
                <div class="extra-ins sub-siis">
                  {{sa.remark?'样品备注：'+sa.remark:''}}
                </div>
          </div>
          <div class="premark" v-if="contract_data.remark">
            <p><span>备注：</span>{{contract_data.remark.customer}}</p>
          </div>
      </div>
    </div>
    <div class="des small-text">
      <div class="des-l">
        <p class="bold-text1">注意事项：</p>
        <div class="des-l-c">
          <p>1.试样截取 &nbsp;&nbsp;{{contract_data.reportInfo.samplePosition}}</p>
          <p>2.检测方法 &nbsp;&nbsp;{{contract_data.reportInfo.testMethod}}</p>
          <p>3.检测分包 &nbsp;&nbsp;{{contract_data.reportInfo.ifSubpackage}}</p>
          <p>4.报告编制 &nbsp;&nbsp;{{contract_data.reportInfo.reportStyle}}</p>
        </div>

      </div>
      <div class="des-r">
        <p class="extra-ins">签发人：<span>{{contract_data.creator}}</span></p>
      </div>
    </div>
    

</div>
</template>
<script>

export default {
  name: "transferPage",
  props: {
    contract_data:{
      type:Object,
    },
    totalPage: {
      type:Number,
      default:0
    },
    currentPage:{
      type:Number,
      default:0
    }
  },
  components: {
  },
  data() {
    return {
      qrImgUrl:process.env.BASE_URL + "img/reportCoverPageLogo.jpg",      
    };
  },
  methods: {
    generateString(tmpList,property_name='text',delimit_icon=','){
      let resList = [];
      for(let i of tmpList){
        resList.push(i[property_name]);
      }
      return resList.join(delimit_icon);
    },
  },
  computed: {
    qrUrl:function(){
      return this.$static_url+'s_i/'+this.contract_data.project_display_no;      
    },
  }
};
</script>
<style scoped>
p{
  margin:0.5rem 0;
}
  .title{
    text-align:center;
    font-size:0.7rem;
    font-family:KaiTi;
  }
  .normal-text{
    font-size:0.5rem;
  }
  .bold-text1{
    font-size:0.6rem;
    font-weight:600;
  }

  .com-name{
    font-size: 0.7rem;
    font-weight: 700;
  }
  .company{
    text-align:left;
    overflow:hidden;
    border-bottom:1px solid #222;
  }

  .customer-info p{
margin:0.3rem 0;
  }

  .right-align{
    text-align: right;
  }

  .two-date p{
    padding: 0;
    margin: 0.1rem 0;
  }

  .loop-sample-wrapper{
    font-size:0.6rem;
  }

  .extra-ins{
    text-align:right;
    padding-right:1rem; 
  }

  .loop-sample-wrapper,.sample-info-item-wrapper{
    border-bottom:1px solid #222;
  }

  .sample-info-item-wrapper:last-child{
    border-bottom:none;
  }
  .des-l{
    font-size:0.5rem;
    border-bottom:1px solid #222;
    padding-bottom:1rem; 
  }
  .des-l-c p{
 padding: 0;
 margin:0;
 text-indent:-0.5rem;
 padding-left:0.5rem;
  }
  .des-r{
    font-size:0.6rem;
    font-weight:700;
  }
  .premark{
    padding: 5px 0;
    font-size:0.5rem;
  }
</style>